
<template>
  <div class="flex flex-col min-h-screen font-Rubik">
    <MainHeader v-if="!route.meta.fullscreen" />
    <!-- <RouterView /> -->
    <RouterView class="flex-1" v-slot="{ Component }">
      <Transition name="page">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <MainFooter v-if="!route.meta.fullscreen" />
  </div>
</template>

<script setup>
  import { RouterView, useRoute } from 'vue-router';
  import MainHeader from '@/components/MainHeader.vue';
  import MainFooter from '@/components/MainFooter.vue';

  // Routes tagged `meta.fullscreen` (e.g. /workspace) render without the
  // persistent header/footer chrome.
  const route = useRoute();
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans&family=Rubik:wght@300;400;500;700&display=swap');

  * {
/*  font-family: "Rubik", sans-serif; */
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .container {
    // max-width: 1100px;
    margin: 0 auto;
  }

  #main-header-nav .router-link-active:not(.branding-link) {
  color: rgb(var(--text-muted));  /* Faded — current page, non-clickable */
  background-color: rgb(var(--surface-active));
  pointer-events: none; /* Makes the link non-clickable */
  cursor: default;     /* Changes the cursor to the default arrow, indicating it's not a clickable link */
  }

  .page-enter-active {
    transition: 600ms ease all;
  }

  .page-enter-from {
    opacity: 0;
  }

</style>
